import { useEffect, useMemo, useState } from "react";
import ContentList from "../../../customUiForCs/ContentList";
import ZoneDropDownInput from "../sites/ZoneDropDownInput";
import SiteDropDownInput from "../employees/SiteDropDownInput";
import MaterialInput from "../../../helperComponents/MaterialInput";
import CommentCard from "../comment/CommentCard";
import { use } from "react";

export default function NomenclatureOfComment({
  userID,
  disableFilters,
  inheritedSearchQuery,
  callback,
}) {
  const [zoneID, setZoneID] = useState(null);
  const [siteID, setSiteID] = useState(null);
  const [date, setDate] = useState(null);

  const queryParams = useMemo(
    () => ({ zoneID, siteID, date }),
    [zoneID, siteID, date]
  );

  useEffect(() => {
    console.log("updated....1");
  }, []);

  return (
    <ContentList
      callback={callback}
      disableFilters={disableFilters}
      inheritedSearchQuery={inheritedSearchQuery}
      //
      userID={userID}
      doReset={() => {
        setZoneID(null);
        setSiteID(null);
        setDate(null);
      }}
      permissionName={"commentPermissions"}
      queryParams={queryParams}
      filters={[
        <MaterialInput
          key="1"
          type="date"
          label={"Date"}
          value={date}
          onChange={(e) => {
            setDate(e.target.value);
          }}
        />,
        <SiteDropDownInput
          key="2"
          onChange={setSiteID}
          value={siteID}
          label="Site"
        />,
        <ZoneDropDownInput
          key="3"
          onChange={setZoneID}
          value={zoneID}
          label="Zone"
        />,
      ]}
      title="Commentaire"
      path="comments"
      CardComponent={CommentCard}
    />
  );
}
